import type { FieldSchema } from 'lorena-templates'

interface Props {
  field: FieldSchema
  value: number
  onChange: (value: number) => void
}

function formatValue(value: number) {
  return `${value.toFixed(2).replace('.', ',')}×`
}

export function RangeField({ field, value, onChange }: Props) {
  const min = typeof field.min === 'number' ? field.min : 0
  const max = typeof field.max === 'number' ? field.max : 100
  const step = typeof field.step === 'number' ? field.step : 1

  return (
    <div className="field">
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12 }}>
        <label htmlFor={field.key}>{field.label}</label>
        <span style={{ color: 'var(--muted)', fontSize: 12, fontVariantNumeric: 'tabular-nums' }}>
          {formatValue(value)}
        </span>
      </div>
      <input
        id={field.key}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
      />
      {field.help && <p className="field-help">{field.help}</p>}
    </div>
  )
}
